import { Link } from "react-router-dom";
import Image from "../../../components/image/Image";

export default function ListingTable({
  title,
  headers,
  loader,
  data,
  totalCount,
  pagination,
  totalPages,
  onPageChange,
  onSearch,
  onSort,
  onDelete,
  searchValue,
  sortConfig
}) {


  function getPaginationRange(totalPages, currentPage) {
    if (totalPages <= 3) return [...Array(totalPages)].map((_, i) => i + 1);
    if (currentPage === 1) return [1, 2, 3];
    if (currentPage === totalPages) return [totalPages - 2, totalPages - 1, totalPages];
    return [currentPage - 1, currentPage, currentPage + 1];
  }

  const getSortClass = (field) => {
    // console.log('Current sort config:', sortConfig, 'Checking field:', field);
    if (sortConfig?.column !== field) return "sortable";
    return sortConfig.direction === "asc" ? "sorted-asc" : "sorted-desc";
  };

  const getRouteType = (title) => {
    if (title.toLowerCase().includes("buyer")) return "buyer";
    if (title.toLowerCase().includes("refinance")) return "refinance";
    if (title.toLowerCase().includes("seller 2 net")) return "seller2net";
    return "seller";
  };

  return (
    <div className="open-tbl-section">
      <div className="set-tbl-height">

        <div className="set-tbl-height-head">
          <h3>{title}</h3>


          <div className="form-group">
            <input
              type="text"
              placeholder="Search Net Sheets"
              value={searchValue}
              className="ic-search"
              onChange={e => onSearch(e.target.value)}
            />
          </div>
        </div>


        {/* TABLE */}
        <div className="table-overflow" >
          <table>
            <thead>
              <tr>
                {headers.map(h => (
                  <th
                    key={h.field}
                    onClick={() => onSort(h.field)}
                    className={getSortClass(h.field)}  // 👈 sorting class added
                    style={{ cursor: "pointer" }}
                  >
                    {h.label}
                  </th>
                ))}
                <th className="txt-center" >Actions</th>
              </tr>
            </thead>

            <tbody>
              {loader ? (
                <tr><td colSpan="5">Loading...</td></tr>
              ) : !data.length ? (
                <tr>
                  <td colSpan={headers.length + 1} style={{ textAlign: "center" }}>
                    No records found.
                  </td>
                </tr>
              ) : (
                data.map(item => (
                  <tr key={item.id}>
                    <td>
                      <Link to={`/${getRouteType(title)}/${item.id}`}>
                        {item.preparedFor}
                      </Link>
                    </td>
                    <td>{item.address}</td>
                    <td>${Number(item.salesPrice).toLocaleString()}</td>
                    <td>
                      {item.createdAt
                        ? new Date(item.createdAt).toLocaleDateString('en-US', {
                          month: 'short',
                          day: '2-digit',
                          year: 'numeric'
                        })
                        : ''}
                    </td>
                    <td className="txt-center">
                      <img
                        src={Image.removeicon}
                        width={15}
                        alt="delete"
                        onClick={() => onDelete(item.id)}
                        style={{ cursor: "pointer" }}
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* MOBILE PAGINATION */}
        {/*   <div className="open-pagination pagination-mobile">*/}
        {totalCount > 10 && (

          <div className="open-pagination pagination-desktop" style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <nav className="pagination">
              <button disabled={pagination.page === 1}
                className={`page prev ${pagination.page === 1 ? "is-disabled" : ""}`}
                onClick={() => onPageChange(pagination.page - 1)}
              >
                Prev
              </button>

              {getPaginationRange(totalPages, pagination.page).map((page, idx) => (
                <button
                  key={idx}
                  className={`page${pagination.page === page ? " is-active" : ""}`}
                  onClick={() => onPageChange(page)}
                >
                  {page}
                </button>
              ))}

              <button disabled={pagination.page === totalPages}
                className={`page next ${pagination.page === totalPages ? "is-disabled" : ""}`}
                onClick={() => onPageChange(pagination.page + 1)}
              >
                Next
              </button>
            </nav>
          </div>
        )}
      </div>
    </div>
  );
}
